import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
  AbstractControl,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "app/_services/common.service";
declare var $: any;
@Component({
  selector: "app-otp-password",
  templateUrl: "./otp-password.component.html",
  styleUrls: ["./otp-password.component.css"],
})
export class OtpPasswordComponent implements OnInit {
  public phone_no;
  public email;
  public userOtpResp;
  public isOtp = false;
  public verifyOtpPhone;
  public verifyOtpEmail;
  public otp;
  public otpResp;
  public isOtpVerified = false;
  public currentUser;
  public userId;
  public password;
  public confirmPassword;
  public isPassword = false;
  public withoutSignupUserId;
  public forgotPasswordPhone;
  public isForgotPassword;

  otpForm = this.formBuilder.group({
    phone_no: [""],
    email: [""],
  });

  verifyOtpForm = this.formBuilder.group({
    otp: [""],
  });

  passwordForm = this.formBuilder.group({
    password: [""],
    confirmPassword: [""],
  });

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {}

  sendUserOtp() {
    console.log(this.otpForm.value, "otpform");
    this.phone_no = this.otpForm.value.phone_no;
    this.email = this.otpForm.value.email;

    if (
      this.phone_no != "" &&
      this.phone_no != null &&
      this.phone_no != undefined
    ) {
      localStorage.setItem("phone_no", JSON.stringify(this.phone_no));
      this.commonService.sendOtpPhone(this.phone_no).subscribe((res) => {
        this.userOtpResp = res;
        if (res.body.isError === true) {
          this.isOtp = false;
          this.showNotification(
            "bottom",
            "right",
            "warning",
            res.body.message,
            "announcement"
          );
        } else {
          this.isOtp = true;
          this.showNotification(
            "bottom",
            "right",
            "success",
            res.body.message,
            "announcement"
          );
        }
      });
    } else if (
      this.email != "" &&
      this.email != null &&
      this.email != undefined
    ) {
      localStorage.setItem("email", JSON.stringify(this.email));
      let input: {};
      input = {
        email: this.email,
      };
      this.commonService.sendOtpEmail(input).subscribe((res) => {
        this.userOtpResp = res;
        this.isOtp = true;
      });
    } else {
      alert("Please fill all the required details");
    }
  }

  verifyUserOtp() {
    this.verifyOtpPhone = JSON.parse(localStorage.getItem("phone_no"));
    this.verifyOtpEmail = JSON.parse(localStorage.getItem("email"));
    this.otp = this.verifyOtpForm.value.otp;

    if (
      this.verifyOtpPhone != "" &&
      this.verifyOtpPhone != null &&
      this.verifyOtpPhone != undefined &&
      this.otp != null &&
      this.otp != "" &&
      this.otp != undefined
    ) {
      let input: {};
      input = {
        phone_no: this.verifyOtpPhone,
        otp: this.otp,
      };
      this.commonService.verifyOtpPhone(input).subscribe((res) => {
        // this.commonService.verifyOtpPhone(this.verifyOtpPhone).subscribe(res => {
        console.log(res, "inside otp phone");
        this.otpResp = res.body;
        if (this.otpResp.message != "Incorrect One Time Password.") {
          // if(this.otpResp.message != "No user found " ){
          this.isOtpVerified = true;
          this.isOtp = false;
          this.showNotification(
            "bottom",
            "right",
            "warning",
            res.body.message,
            "announcement"
          );
        } else {
          alert("Incorrect One Time Password.");
        }
      });
    } else if (
      this.verifyOtpEmail != "" &&
      this.verifyOtpEmail != null &&
      this.verifyOtpEmail != undefined &&
      this.otp != null &&
      this.otp != "" &&
      this.otp != undefined
    ) {
      let input: {};
      input = {
        email: this.verifyOtpEmail,
        otp: this.otp,
      };
      this.commonService.verifyOtpEmail(input).subscribe((res) => {
        console.log(res, "inside otp email");
        this.otpResp = res.body;
        if (this.otpResp.message != "Incorrect One Time Password.") {
          this.isOtpVerified = true;
          this.isOtp = false;
        } else {
          alert("Incorrect One Time Password.");
        }
      });
    } else {
      alert("Please fill all the details");
    }
  }

  setPassword() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.withoutSignupUserId = JSON.parse(localStorage.getItem("user_id"));
    this.forgotPasswordPhone = JSON.parse(
      localStorage.getItem("forgotPasswordPhone")
    );
    this.isForgotPassword = localStorage.getItem("isForgotPassword");

    if (
      this.forgotPasswordPhone != null &&
      this.forgotPasswordPhone != "" &&
      this.forgotPasswordPhone != undefined
    ) {
      this.password = this.passwordForm.value.password;
      this.confirmPassword = this.passwordForm.value.confirmPassword;

      if (
        this.password != null &&
        this.password != "" &&
        this.confirmPassword != null &&
        this.confirmPassword != "" &&
        this.password === this.confirmPassword
      ) {
        let input: {};
        input = {
          phone_no: this.forgotPasswordPhone,
          password: this.password,
        };
        this.commonService.forgetPassword(input).subscribe((res) => {
          console.log(res, "inside password");
          this.isPassword = true;

          if (this.isForgotPassword == "true") {
            this.router.navigate(["/login"]);
          } else {
            this.router.navigate(["/additional-details"]);
          }

          // this.router.navigate(['/food-service']);
        });
      } else {
        alert("Please fill in the correct password");
      }
    } else {
      if (this.currentUser != null) {
        this.userId = this.currentUser.data.user_id;
      } else {
        this.userId = this.withoutSignupUserId;
      }
      // this.userId = this.currentUser.data.user_id ? this.currentUser.data.user_id : this.withoutSignupUserId ;
      this.password = this.passwordForm.value.password;
      this.confirmPassword = this.passwordForm.value.confirmPassword;

      if (
        this.password != null &&
        this.password != "" &&
        this.confirmPassword != null &&
        this.confirmPassword != "" &&
        this.password === this.confirmPassword
      ) {
        let input: {};
        input = {
          user_id: this.userId,
          password: this.password,
        };
        this.commonService.setPassword(input).subscribe((res) => {
          console.log(res, "inside password");
          this.isPassword = true;
          this.router.navigate(["/additional-details"]);

          // this.router.navigate(['/food-service']);
        });
      } else {
        alert("Please fill in the correct password");
      }
    }
  }

  getAllUser() {
    let allUsers;
    this.commonService.getAllUser().subscribe((res) => {
      allUsers = res.body.data;
      console.log(allUsers);
    });
  }
  showNotification(from, align, color, stringMessage, icons) {
    const type = ["", "info", "success", "warning", "danger"];

    $.notify(
      {
        icon: icons,
        message: stringMessage,
      },
      {
        type: type[color],
        timer: 4000,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }
}
